import type {
  InputHTMLAttributes,
  LabelHTMLAttributes,
  ReactNode,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";
import { cn } from "../../lib/cn";

export function Input({
  className,
  ...props
}: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={cn("desk-input w-full px-3 py-2 text-body-sm font-data-mono", className)}
      {...props}
    />
  );
}

export function Select({
  className,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select
      className={cn("desk-input w-full px-3 py-2 text-body-sm font-data-mono", className)}
      {...props}
    />
  );
}

export function Textarea({
  className,
  ...props
}: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      className={cn(
        "desk-input w-full px-3 py-2 text-body-sm font-data-mono resize-y min-h-[4rem]",
        className,
      )}
      {...props}
    />
  );
}

export function FieldLabel({
  children,
  className,
  ...props
}: LabelHTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cn(
        "font-data-label text-data-label uppercase text-on-surface-variant",
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}

export function Field({
  label,
  children,
  className,
}: {
  label: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <label className={cn("flex flex-col gap-1.5 min-w-0", className)}>
      <FieldLabel>{label}</FieldLabel>
      {children}
    </label>
  );
}
